import { Preset } from "~/normalizr/entities";
import { EntitiesActionTypes, EntityNames } from "~/Redux/Entities";

export const updatePresetEntity = (item: Partial<Preset>) => ({
    type: EntitiesActionTypes.UPDATE_ENTITIES,
    entities: {
        [EntityNames.presets]: {
            [item.Id]: item,
        },
    },
});
